<import name="Header" from="./header.html" />
<import name="CustomizationProvider" from="./customization" />
<template name="RichIdeasHeader">
    <div class="new-container">
        <CustomizationProvider>
            <Header isRichIdeas richIdeasBase={RICH_IDEAS_BASE}></Header>
        </CustomizationProvider>
    </div>
</template>
